export default __webpack_public_path__ + "static/media/RESPONSABILIDAD.e82ebacf.jpg";